/* ============================================================
   Review
   - product-detail-review-custom.liquid (data 속성) + product-detail-review-custom.css 와 함께 사용
   - 진입점: 페이지에 #product-detail-review-custom 이 있으면 자동 초기화
   ============================================================ */
(() => {
  'use strict';

  /* ----- 설정 ----- */
  const CONFIG = {
    apiBase: 'https://prod-external-api.moomooz.com/api/external/review/',
    pageSize: 10,
    text: {
      count: (n) => `韓国ママたちの声 ${n}件`, // 한국 엄마들의 이야기
      note: '※翻訳は参考用であり、原文と内容が異なる場合があります。', // 번역은 참고용이며 원문과 차이가 있을 수 있음
      error: '声を読み込めませんでした。', // 이야기를 불러올 수 없었습니다.
    },
  };

  /* ----- 유틸 ----- */
  const stars = (n = 0) => '★★★★★'.slice(0, n) + '☆☆☆☆☆'.slice(0, 5 - n);

  const createReviewItem = (rv, onImageClick) => {
    const li = document.createElement('li');
    li.className = 'product-detail-review-custom__item';

    const head = document.createElement('div');
    head.className = 'product-detail-review-custom__head';
    const starSpan = document.createElement('span');
    starSpan.className = 'product-detail-review-custom__stars';
    starSpan.textContent = stars(rv.rating);
    const nameSpan = document.createElement('span');
    nameSpan.textContent = rv.memberNameJp || '';
    head.append(starSpan, nameSpan);
    li.append(head);

    const opts = (rv.selectedOptions || []).map((o) => o.value).join(' / ');
    if (opts) {
      const optEl = document.createElement('div');
      optEl.className = 'product-detail-review-custom__options';
      optEl.textContent = opts;
      li.append(optEl);
    }

    const images = (rv.images || [])
      .map((im) => ({ large: im.large || im.thumbnail || '', thumb: im.thumbnail || im.large || '' }))
      .filter((im) => im.large);

    if (images.length) {
      const largeList = images.map((im) => im.large);
      const wrap = document.createElement('div');
      wrap.className = 'product-detail-review-custom__thumbs';
      images.forEach((im, idx) => {
        const img = document.createElement('img');
        img.className = 'product-detail-review-custom__thumb';
        img.src = im.thumb;
        img.alt = '';
        img.addEventListener('click', () => onImageClick(largeList, idx));
        wrap.append(img);
      });
      li.append(wrap);
    }

    const body = document.createElement('p');
    body.className = 'product-detail-review-custom__body';
    body.textContent = rv.contentJp;
    li.append(body);

    return li;
  };

  /* ----- API 클라이언트 ----- */
  const createReviewAPI = (productNo, token) => {
    const fetchPage = async (page) => {
      const url =
        CONFIG.apiBase +
        encodeURIComponent(productNo) +
        `?pageNumber=${page}&pageSize=${CONFIG.pageSize}`;
      const res = await fetch(url, { headers: { 'X-External-Token': token } });
      return res.json();
    };
    return { fetchPage };
  };

  /* ----- 라이트박스 (범용 이미지 뷰어) ----- */
  const createLightbox = () => {
    let list = [];
    let idx = 0;

    const el = document.createElement('div');
    el.className = 'product-detail-review-lightbox';
    el.innerHTML =
      '<span class="product-detail-review-lightbox__nav product-detail-review-lightbox__nav--prev">‹</span>' +
      '<img class="product-detail-review-lightbox__img" alt="">' +
      '<span class="product-detail-review-lightbox__nav product-detail-review-lightbox__nav--next">›</span>' +
      '<span class="product-detail-review-lightbox__close">×</span>';
    document.body.append(el);

    const img = el.querySelector('.product-detail-review-lightbox__img');

    const render = () => {
      img.src = list[idx];
      el.classList.toggle('is-single', list.length <= 1);
    };
    const isOpen = () => el.classList.contains('is-open');
    const open = (newList, newIdx) => {
      list = newList;
      idx = newIdx;
      el.classList.add('is-open');
      render();
    };
    const close = () => el.classList.remove('is-open');
    const prev = () => { idx = (idx - 1 + list.length) % list.length; render(); };
    const next = () => { idx = (idx + 1) % list.length; render(); };

    el.querySelector('.product-detail-review-lightbox__nav--prev')
      .addEventListener('click', (e) => { e.stopPropagation(); prev(); });
    el.querySelector('.product-detail-review-lightbox__nav--next')
      .addEventListener('click', (e) => { e.stopPropagation(); next(); });
    el.querySelector('.product-detail-review-lightbox__close')
      .addEventListener('click', (e) => { e.stopPropagation(); close(); });
    el.addEventListener('click', (e) => { if (e.target === el) close(); });

    document.addEventListener('keydown', (e) => {
      if (!isOpen()) return;
      if (e.key === 'ArrowLeft') prev();
      else if (e.key === 'ArrowRight') next();
      else if (e.key === 'Escape') close();
    });

    let startX = 0, startY = 0;
    el.addEventListener('touchstart', (e) => {
      startX = e.changedTouches[0].clientX;
      startY = e.changedTouches[0].clientY;
    }, { passive: true });
    el.addEventListener('touchend', (e) => {
      const dx = e.changedTouches[0].clientX - startX;
      const dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
        dx > 0 ? prev() : next();
      }
    }, { passive: true });

    return { open };
  };

  /* ----- 리뷰 위젯 (조립 + 페이지네이션) ----- */
  const createReviewWidget = (root) => {
    const listEl = root.querySelector('.product-detail-review-custom__list');
    const summaryEl = root.querySelector('.product-detail-review-custom__summary');
    const noteEl = root.querySelector('.product-detail-review-custom__note');
    const moreBtn = root.querySelector('.product-detail-review-custom__more');

    const productNo = (root.dataset.productNo || '').split('_')[0];
    const api = createReviewAPI(productNo, root.dataset.token || '');
    const lightbox = createLightbox();

    let page = 0;
    let shownCount = 0;

    const loadNext = async () => {
      try {
        const data = await api.fetchPage(page);
        const items = (data.content || []).filter((rv) => rv.contentJp && rv.contentJp.trim());

        items.forEach((rv) => {
          const li = createReviewItem(rv, (l, i) => lightbox.open(l, i));
          listEl.append(li);
          shownCount += 1;
        });

        page = data.currentPage + 1;
        const hasMore = page < data.totalPages;

        // 이 페이지에 표시할 JP 리뷰가 0개지만 다음 페이지가 있으면 계속 로드
        if (items.length === 0 && hasMore) {
          loadNext();
          return;
        }

        moreBtn.classList.toggle('is-visible', hasMore);

        if (!hasMore && shownCount === 0) {
          // 리뷰가 하나도 없으면 영역 전체를 제거
          root.remove();
        } else if (shownCount > 0) {
          summaryEl.textContent = CONFIG.text.count(shownCount);
          noteEl.classList.add('is-visible');
        }
      } catch (err) {
        summaryEl.textContent = CONFIG.text.error;
        console.error('[product-detail-review-custom]', err);
      }
    };

    const init = () => {
      if (noteEl) noteEl.textContent = CONFIG.text.note;
      moreBtn.addEventListener('click', () => loadNext());
      loadNext();
    };

    return { init };
  };

  /* ----- 진입점 ----- */
  const init = () => {
    const root = document.getElementById('product-detail-review-custom');
    if (root) createReviewWidget(root).init();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();